// Client V1 imports
const { track } = require('client/lib/analytics')
const airbrake = require('client/lib/airbrake')

const SHOW = 'AUTH_MODAL_SHOW'
const HIDE = 'AUTH_MODAL_HIDE'

function show(hasAccount) {
  track('auth-login-modal', { hasAccount })
  return {
    type: SHOW,
    payload: { hasAccount }
  }
}

function showLogin() {
  return show(true)
}

function showSignup() {
  return show(false)
}

function showSULogin() {
  return socialAuth('stumbleupon', true)
}

function hide() {
  return {
    type: HIDE
  }
}

function socialAuth(provider, hasAccount) {
  return function () {
    track('social-auth', {
      hasAccount,
      provider,
      authContext: 'login-modal',
      metabase: {
        'actioned_object_type': 'provider',
        'actioned_object_id': provider
      }
    })
    .then(() => {
      const r = encodeURIComponent(location.pathname + location.search)
      location.assign(`/auth/${provider}?r=${r}`)
    })
    .catch(err => airbrake.notify(err))
  }
}

module.exports = {
  SHOW,
  HIDE,
  show,
  showLogin,
  showSignup,
  showSULogin,
  hide,
  socialAuth
}
